export module ToastService {
    const _defaultOptions: ToastrOptions =
    {
        progressBar: true
    }

    export interface IToastRequest {
        RemoveExistingToasts: boolean,
        Message: string,
        Status: "Error" | "Success" | "Info" | "Warning",
        Options?: ToastrOptions;
    }

    export function sendToast(request: IToastRequest) {
        // If no options are defined, use the default settings
        request.Options ??= _defaultOptions;

        if (request.RemoveExistingToasts) {
            // Remove existing toasts from the screen
            toastr.remove()
        }

        const toastrFunc = (toastr as any)[request.Status.toLowerCase()];
        toastrFunc(request.Message, "", request.Options);
    }
}